import styled from 'styled-components';

export function TitleTooltip({ text }) {
  return <CaptionComponent>{text}</CaptionComponent>;
}

const CaptionComponent = styled.span``;
